
import { SiteUrls } from '@tableau/shared-urls';
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { ColumnsReferencingFieldColumnsFragment, ColumnsReferencingFieldQuery, ColumnsReferencingFieldQueryVariables , ColumnsReferencingFieldDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { LinksDisplayGrid, LinksDisplayGridRowData } from '../sharedDisplayGrid/LinksDisplayGrid';

interface ColumnsReferencingFieldGridRowData extends LinksDisplayGridRowData {
  readonly tableId: string;
  readonly tableName: string;
  readonly tableIsCustomSql: boolean;
}

type QueryVariables = ColumnsReferencingFieldQueryVariables;
type QueryResults = ColumnsReferencingFieldQuery;
type QueryResultListNode = ColumnsReferencingFieldColumnsFragment;
type GridRowData = ColumnsReferencingFieldGridRowData;

function selectConnectionListResult(resultData: ColumnsReferencingFieldQuery): ConnectionListResult<QueryResultListNode> | null {
  if (resultData && resultData.fields && resultData.fields[0] && resultData.fields[0].__typename === 'ColumnField') {
    return (resultData.fields[0]).columnsConnection;
  }
  return null;
}

function mapResultNode(node: QueryResultListNode): GridRowData {
  return {
    id: node.id,
    name: node.name,
    tableId: node.table && node.table.id || '',
    tableName: node.table && node.table.name || '',
    tableIsCustomSql: !!(node.table && node.table.__typename === 'CustomSQLTable')
  };
}

function urlForLink(urls: SiteUrls, rowData: ColumnsReferencingFieldGridRowData) {
  return rowData.tableIsCustomSql
    ? null
    : urls.catalogTableColumnPath(rowData.tableId, rowData.id);
}

function nameForLink(rowData: ColumnsReferencingFieldGridRowData): string | null {
  if (rowData.name === null) {
    return null;
  }

  return Messages.LinkNameWithParent({ name: rowData.name, parentName: rowData.tableName });
}

export type ColumnsReferencingFieldQueryGridProps = {
  readonly fieldId: string;
  readonly rowCount: number | null;
};

export function ColumnsReferencingFieldQueryGrid(props: ColumnsReferencingFieldQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyFieldUsedByColumnsGridMessage();
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={ColumnsReferencingFieldDocument}
      partialQueryVariables={{ fieldId: props.fieldId }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={mapResultNode}
    >
      {({ rowStore }) =>
        <LinksDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          link={urlForLink}
          name={nameForLink}
        />
      }
    </PaginatedQueryWrapper>
  );
}
